import React from 'react';
import { animateScroll } from 'react-scroll'
import { FaArrowUp } from 'react-icons/fa'

import * as styles from './styles.module.css'

import useScrollPercentage from '../../hooks/useScrollPercentage'

function ProgressArrow()
{
  const percentage = useScrollPercentage()

  return (
    <button className={styles.progressWrap + " " + (percentage > 0 && styles.activeProgress)}
      onClick={() => animateScroll.scrollToTop({ duration: "500" })}
    >
      <FaArrowUp className="absolute text-2xl text-orange h-full w-full p-2" />
      <svg className="progress-circle svg-content" width="100%" height="100%" viewBox="-1 -1 102 102">
        <path
          className={styles.progressCirclePath}
          d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
          style={{
            strokeDashoffset: 307.919 - (percentage * 307.919)
          }}
        ></path>
      </svg>
    </button>
  );
}

export default ProgressArrow;